/* ALBEUX PRODUCT PAGE: VIDEO (Task 7, smooth-swipe pass 31 Oct 2026, steadier pass 1 Nov 2026)
   Any video among the product photographs plays by itself: no play button to press.
   - SMOOTH START: the video is loaded in the background BEFORE the customer reaches it (one swipe away on a phone, half a screen away on a computer),
     and it waits paused. The photograph stays on screen until the video is really PLAYING, then the two swap, so there is never a blank or black moment.
   - It starts the moment the video is half on screen, plays muted and loops continuously.
   - When the customer swipes or scrolls away it pauses and the photograph comes back at once. The video goes back to its first frame a moment later,
     once it is out of sight (rewinding while it was still on screen made the picture flicker while swiping).
   - Works for uploaded videos and for YouTube / Vimeo videos (those cannot be pre-loaded, they load when reached). Several videos on screen at once all play.
   - A tap on the video still pauses and plays it.
   - On phones the next photographs are decoded in the background just ahead of the swipe.
   - Nothing is pre-loaded in data-saver mode. Pre-loading waits until the page has finished loading, so the photographs always get the connection first.
   Does not change any font, size or colour. Styling is in albeux-product-video.css.
   To switch it off, delete the albeux-product-video.js and albeux-product-video.css lines in snippets/albeux-fixes.liquid.

   GALLERY HEIGHT FIT: photographs are square and a video keeps its own shape (see albeux-product-video.css). On a phone the photographs are swiped in a row,
   so this part makes the row exactly as tall as the picture on screen. It only does anything on products that have a video.
   Steadier pass (1 Nov 2026): the row is resized only AFTER a swipe has come to rest, never while the photographs are still moving, which made the picture shiver. */
(function () {
  'use strict';
  if (window.__albeuxProductVideo) return;
  window.__albeuxProductVideo = true;
  if (!('IntersectionObserver' in window)) return;

  var SELECTOR = "main[data-template^='product'] media-gallery deferred-media";
  var inView = new Set();
  var conn = navigator.connection || null;
  var saveData = !!(conn && conn.saveData);

  function presented(el) {
    var all = el.querySelectorAll('video');
    return all.length ? all[all.length - 1] : null;
  }

  function usable(el) {
    return typeof el.loadContent === 'function' && typeof el.playMedia === 'function';
  }

  /* An uploaded video (not YouTube / Vimeo) can be loaded ahead of time by this script */
  function plainVideo(el) {
    var t = el.querySelector('template');
    if (!t || !t.content) return false;
    return !t.content.querySelector('iframe') && !!t.content.querySelector('video');
  }

  function prepare(el) {
    el.querySelectorAll('video').forEach(function (v) {
      v.loop = true;
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
    });
  }

  /* Puts the video in place, PAUSED. The photograph stays on screen until the video is really playing, then they swap with no gap. */
  function load(el) {
    if (el.hasAttribute('data-media-loaded')) return presented(el);
    if (!plainVideo(el)) {
      try { el.loadContent(false); } catch (e) {}
      return presented(el);
    }
    var tpl = el.querySelector('template');
    var src = tpl && tpl.content && tpl.content.firstElementChild;
    if (!src) return null;
    var v = src.cloneNode(true);
    v.removeAttribute('autoplay');
    v.autoplay = false;
    v.loop = true;
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.preload = 'auto';
    var btn = el.querySelector('[ref="deferredMediaPlayButton"]');
    /* The swap happens on "playing" (a picture is really being shown), not on "loadeddata": a paused video can be loaded and still draw nothing on a phone, which left a blank square */
    var reveal = function () { if (btn) btn.classList.add('deferred-media__playing'); };
    v.addEventListener('playing', reveal);
    el.setAttribute('data-media-loaded', 'true');
    el.appendChild(v);
    return v;
  }

  function playing(el) {
    var v = presented(el);
    return !!v && !v.paused;
  }

  function play(el) {
    if (!usable(el)) return;
    clearTimeout(el.__albRewind);
    load(el);
    prepare(el);
    var v = presented(el);
    if (v) {
      if (v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      el.isPlaying = true;
      if (el.updatePlayPauseHint) el.updatePlayPauseHint(true);
    } else if (el.querySelector('iframe[data-video-type]')) {
      el.playMedia();
    }
  }

  function stop(el) {
    if (!usable(el) || !el.hasAttribute('data-media-loaded')) return;
    el.pauseMedia();
    if (plainVideo(el)) {
      /* The photograph comes back at once; the video is rewound only after it has been out of sight for a moment */
      var btn = el.querySelector('[ref="deferredMediaPlayButton"]');
      if (btn) btn.classList.remove('deferred-media__playing');
      clearTimeout(el.__albRewind);
      el.__albRewind = setTimeout(function () {
        if (inView.has(el)) return;
        el.querySelectorAll('video').forEach(function (v) {
          try { v.currentTime = 0; } catch (e) {}
        });
      }, 700);
    } else {
      el.querySelectorAll('video').forEach(function (v) {
        try { v.currentTime = 0; } catch (e) {}
      });
    }
  }

  /* Loading one video can make the theme pause every other video, so the ones that were already playing are started again */
  function enter(el) {
    var others = [];
    inView.forEach(function (o) { if (playing(o)) others.push(o); });
    inView.add(el);
    play(el);
    others.forEach(play);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      var r = e.intersectionRect;
      var b = e.boundingClientRect;
      var h = r.height / Math.max(1, Math.min(b.height, window.innerHeight));
      var w = r.width / Math.max(1, Math.min(b.width, window.innerWidth));
      var on = e.isIntersecting && h >= 0.5 && w >= 0.5;
      if (on && !inView.has(el)) {
        enter(el);
      } else if (!on && inView.has(el)) {
        inView.delete(el);
        stop(el);
      }
    });
  }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] });

  /* ---------- Pre-load: get the video ready before the customer reaches it ---------- */
  function warm(el) {
    if (el.__albWarm) return;
    el.__albWarm = true;
    if (usable(el) && plainVideo(el)) load(el);
  }

  function nearCallback(entries, obs) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      obs.unobserve(e.target);
      warm(e.target);
    });
  }

  /* Computer: half a screen above and below. Phone: the photographs sit in a sideways row, so the row itself is the frame (about one swipe either side). */
  var nearPage = new IntersectionObserver(nearCallback, { rootMargin: '50% 0px 50% 0px' });
  var nearRows = new WeakMap();
  function nearFor(row) {
    var o = nearRows.get(row);
    if (!o) {
      o = new IntersectionObserver(nearCallback, { root: row, rootMargin: '0px 110% 0px 110%' });
      nearRows.set(row, o);
    }
    return o;
  }

  /* Pre-loading starts a moment AFTER the page has finished loading, so the photographs always get the connection first */
  function whenCalm(fn) {
    var go = function () { setTimeout(fn, 800); };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  /* ---------- Decode the next photographs just ahead of the swipe (phones) ---------- */
  function decodeAround(gal, active) {
    if (saveData) return;
    try {
      var row = gal.querySelector('slideshow-slides');
      if (!row || !active) return;
      var slides = [].slice.call(row.querySelectorAll('slideshow-slide')).filter(function (s) { return !s.hasAttribute('hidden'); });
      var i = slides.indexOf(active);
      if (i < 0) return;
      [i + 1, i + 2, i - 1].forEach(function (j) {
        var s = slides[j];
        var img = s && s.querySelector('.product-media__image');
        if (img && img.decode && !img.__albDec) {
          img.__albDec = 1;
          img.decode().catch(function () {});
        }
      });
    } catch (e) {}
  }

  /* ---------- Gallery height fit (phones: the swipe row is as tall as the picture on screen) ---------- */
  var fitGalleries = [];

  function fitOne(gal) {
    try {
      var row = gal.querySelector('slideshow-slides');
      if (!row) return;
      var active = row.querySelector('slideshow-slide[aria-hidden="false"]') || row.querySelector('slideshow-slide');
      if (!active) return;
      decodeAround(gal, active);
      var box = active.querySelector('.product-media-constraint-wrapper') || active.querySelector('.product-media') || active;
      var h = Math.round(box.getBoundingClientRect().height);
      if (h < 40) return;
      if (row.style.height === h + 'px') return;
      row.style.height = h + 'px';
      if (!gal.hasAttribute('data-alb-fit')) {
        requestAnimationFrame(function () { gal.setAttribute('data-alb-fit', '1'); });
      }
    } catch (e) {}
  }

  function hookFit(gal) {
    if (!gal || gal.__albFit) return;
    gal.__albFit = true;
    fitGalleries.push(gal);
    fitOne(gal);
    var row = gal.querySelector('slideshow-slides');
    var lastScroll = 0;
    var timer = 0;
    if (row) row.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true });
    /* Resize only once the swipe has come to rest */
    function later() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (Date.now() - lastScroll < 150) { later(); return; }
        fitOne(gal);
      }, 140);
    }
    if ('MutationObserver' in window) {
      new MutationObserver(later).observe(gal, { attributes: true, attributeFilter: ['aria-hidden'], subtree: true });
    }
  }

  var fitTimer = 0;
  window.addEventListener('resize', function () {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(function () {
      fitGalleries = fitGalleries.filter(function (g) { return g.isConnected; });
      fitGalleries.forEach(fitOne);
    }, 150);
  }, { passive: true });

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.hasAttribute('data-albeux-video') || el.closest('dialog')) return;
      el.setAttribute('data-albeux-video', '1');
      io.observe(el);
      if (!saveData) {
        var row = el.closest('slideshow-slides');
        var obs = row ? nearFor(row) : nearPage;
        whenCalm(function () { if (el.isConnected) obs.observe(el); });
      }
      hookFit(el.closest('media-gallery'));
    });
  }

  document.addEventListener('visibilitychange', function () {
    inView.forEach(function (el) {
      if (document.hidden) {
        if (usable(el) && el.hasAttribute('data-media-loaded')) el.pauseMedia();
      } else {
        play(el);
      }
    });
  });

  function start() {
    document.documentElement.classList.add('albeux-vid');
    scan();
    /* The photographs are replaced when a colour is chosen, so look again whenever the page changes (only inside the page content) */
    var queued = false;
    var root = document.getElementById('MainContent') || document.documentElement;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; scan(); });
    }).observe(root, { childList: true, subtree: true });
  }

  var defined = (window.customElements && customElements.whenDefined) ? customElements.whenDefined('deferred-media') : Promise.resolve();
  defined.then(function () {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  });
})();